import { endOfWeek } from 'date-fns';
import { nlBE } from 'date-fns/locale';

export const nlBELocaleEndOfWeek = (val: Date): Date => {
    return endOfWeek(val, { locale: nlBE });
}